/**
 * The Google Forms URL shapes the importer accepts (`POST
 * /v1/quiz-platform/import/google-forms` validates the same pattern). One
 * source for the author-studio modal and the homepage teachers band, so a
 * link the homepage accepts is never refused a page later.
 */
export const GOOGLE_FORMS_URL_PATTERN =
  /^https?:\/\/(docs\.google\.com\/forms\/d\/[A-Za-z0-9_-]+|forms\.gle\/[A-Za-z0-9_-]+)/;

export function isGoogleFormsUrl(value: string): boolean {
  return GOOGLE_FORMS_URL_PATTERN.test(value.trim());
}

/** The author studio opens the import modal prefilled when it sees this query key. */
export const IMPORT_URL_QUERY_KEY = "importUrl";

export function authorStudioImportHref(locale: string, formsUrl: string): string {
  // The quiz list, where the import lives since `AD-DSH04` turned the Studio home into a summary.
  return `/${locale}/dashboard/author-studio/quizzes?${IMPORT_URL_QUERY_KEY}=${encodeURIComponent(formsUrl.trim())}`;
}
